export enum CrudStoreItemScout {
  WW_PartnerFlags = 'WW_PartnerFlags',
  WW_PartnerFlags_Inactive = 'WW_PartnerFlags_Inactive',
  PartnerListCSI = 'PartnerListCSI',
  WW_PartnerFlags_DateFormat = 'WW_PartnerFlags_DateFormat',
}
